import type { CreatorInfoBlock as CreatorInfoBlockType } from '@/shared/types/blocks';
import { Avatar, AvatarFallback, AvatarImage } from '@/shared/ui/avatar';

/**
 * CreatorInfoBlock - 제작자 정보
 *
 * Figma 디자인 기준:
 * - 이름: label-smaller-b (12px Bold)
 * - 아바타: 32x32px
 */
export function CreatorInfoBlock({ name, avatar }: Omit<CreatorInfoBlockType, 'type' | 'id'>) {
  return (
    <div className="flex items-center gap-2 h-8">
      <Avatar className="w-8 h-8 rounded-full bg-label-disabled">
        <AvatarImage src={avatar} alt={name} />
        <AvatarFallback>{name.charAt(0)}</AvatarFallback>
      </Avatar>
      <span className="label-smaller-b text-black">{name}</span>
    </div>
  );
}
